interface Node {
  cx: number
  cy: number
  r: number
  delay?: string
}

const HUB: Node = { cx: 200, cy: 200, r: 11 }

const NODES: Node[] = [
  { cx: 92, cy: 118, r: 5, delay: '0s' },
  { cx: 304, cy: 84, r: 4, delay: '0.6s' },
  { cx: 338, cy: 226, r: 5, delay: '1.1s' },
  { cx: 254, cy: 334, r: 4, delay: '0.3s' },
  { cx: 116, cy: 306, r: 5, delay: '0.9s' },
  { cx: 56, cy: 204, r: 4, delay: '1.4s' },
]

const LINKS: [Node, Node][] = [
  [HUB, NODES[0]],
  [HUB, NODES[1]],
  [HUB, NODES[2]],
  [HUB, NODES[3]],
  [HUB, NODES[4]],
  [HUB, NODES[5]],
  [NODES[0], NODES[5]],
  [NODES[1], NODES[2]],
  [NODES[3], NODES[4]],
]

/**
 * Firma visual de la pantalla de login: una red de nodos conectados, ampliando el mismo
 * motivo del isotipo (ver components/ui/Logo.tsx) -- "nexo" como punto de union. Las
 * lineas fluyen (stroke-dashoffset animado) y los nodos flotan con retrasos distintos
 * para que se sienta viva sin ser ruidosa. prefers-reduced-motion la congela (ver index.css).
 */
export function NexoNetworkAnimation() {
  return (
    <div className="flex flex-col items-center gap-6">
      <svg viewBox="0 0 400 400" className="h-96 w-96 overflow-visible xl:h-[28rem] xl:w-[28rem]">
        {LINKS.map(([a, b], i) => (
          <line
            key={i}
            x1={a.cx}
            y1={a.cy}
            x2={b.cx}
            y2={b.cy}
            stroke="var(--color-orange)"
            strokeOpacity={0.5}
            strokeWidth={2}
            strokeDasharray="5 7"
            className="animate-[line-flow_2.2s_linear_infinite]"
          />
        ))}
        {NODES.map((n, i) => (
          <circle
            key={i}
            cx={n.cx}
            cy={n.cy}
            r={n.r}
            fill="var(--color-text)"
            className="animate-[node-float_5.5s_ease-in-out_infinite]"
            style={{ animationDelay: n.delay, transformBox: 'fill-box', transformOrigin: 'center' }}
          />
        ))}
        <circle
          cx={HUB.cx}
          cy={HUB.cy}
          r={HUB.r}
          fill="var(--color-accent)"
          className="animate-[hub-pulse_3.2s_ease-in-out_infinite]"
          style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
        />
      </svg>
      <p className="max-w-xs text-center text-sm font-medium text-muted">
        Tu centro personal de proyectos, ideas y finanzas.
      </p>
    </div>
  )
}
